import {CreateSlice} from 'base'

export interface ProjectSlice {
  projectDocumentsTabs: any
  isDrawdownRequestOpen: boolean

  setProjectDocumentsTabs: (projectUuid: string, tabs: any[]) => void
  setDrawdownRequestOpen: (isDrawdownRequestOpen: boolean) => void
}

const getInitialDocumentsTabs = (): any => {
  const storageDocumentsTabs = localStorage.getItem('projectDocumentsTabs')
  if (storageDocumentsTabs) return JSON.parse(storageDocumentsTabs)
  return {}
}

const createProjectSlice: CreateSlice<ProjectSlice> = (set) => ({
  projectDocumentsTabs: getInitialDocumentsTabs(),
  isDrawdownRequestOpen: false,

  setProjectDocumentsTabs: (projectUuid, tabs) =>
    set((state) => {
      const newProjectDocumentTabs = {
        ...state.projectDocumentsTabs,
        [projectUuid]: tabs,
      }
      localStorage.setItem(
        'projectDocumentsTabs',
        JSON.stringify(newProjectDocumentTabs)
      )
      return {
        projectDocumentsTabs: newProjectDocumentTabs,
      }
    }),
  setDrawdownRequestOpen: (isDrawdownRequestOpen) =>
    set(() => ({isDrawdownRequestOpen})),
})

export default createProjectSlice
